export default "__VITE_ASSET__DTz2e40c__"